<template>
  <div id="app">
    <Layout class="ivu-layout-has-sider" style="height: 100%">
      <!-- 路由菜单 -->
      <div v-show="$store.state.isShowHead">
        <SiteMenu ref="siteMenu" v-if="$store.state.labelType == 1"></SiteMenu>
        <ApplyMenu ref="applyMenu" v-if="$store.state.labelType == 0"></ApplyMenu>
        <InstitutionMenu ref="institutionMenu" v-if="$store.state.labelType == 2"></InstitutionMenu>
      </div>
      <Layout style="background: rgba(243, 243, 243, 1);">
        <!-- 头部信息 -->
        <div v-show="$store.state.isShowHead">
          <InstitutionHeader v-if="$store.state.labelType == 2"></InstitutionHeader>
          <CommonHeader v-else></CommonHeader>
        </div>
        <Content class="layout-content height-100">
          <!-- 子菜单容器 -->
          <div class="submenu-container">
            <div class="submenu-wrapper" v-if="$store.state.labelType == 0 && $store.state.showSubMenu">
              <div class="submenu-item" v-for="(item, index) in $store.state.subMenuItems" :key="index" :class="{ 'active-submenu': isSubMenuActive(item.path) }" @click="handleSubMenuClick(item)">
                {{ item.title }}
              </div>
            </div>
            <div class="show-btn" v-if="$store.state.labelType == 0" @click="toggleSubMenu">
              <Icon :type="$store.state.showSubMenu ? 'md-arrow-dropleft' : 'md-arrow-dropright'" size="16" color="#fff" />
            </div>
          </div>
          <!-- 主视图 -->
          <div style="background: rgba(243, 243, 243, 1);" :class="[$store.state.labelType != -1 ? 'main-view' : '', 'content-body']">
            <keep-alive>
              <router-view ref="reload" v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view ref="reload" v-if="!$route.meta.keepAlive"></router-view>
          </div>
        </Content>
      </Layout>
    </Layout>
    <!-- MQTT消息 -->
    <MqttNotice></MqttNotice>
  </div>
</template>

<script>
// 引入生成二维码插件
import vueQr from 'vue-qr'
// 站点路由
import SiteMenu from '@/components/layout/menu/siteMenu.vue'
// 应用路由
import ApplyMenu from '@/components/layout/menu/applyMenu.vue'

import InstitutionMenu from '@/components/layout/menu/institutionMenu.vue'
// 头部信息
import CommonHeader from '@/components/layout/header/commonHeader.vue'
// MQTT消息
import MqttNotice from '@/components/msgNotice/MqttNotice.vue'
import InstitutionHeader from '@/components/layout/header/institutionHeader.vue'

export default {
  components: {
    InstitutionHeader,
    SiteMenu,
    ApplyMenu,
    InstitutionMenu,
    CommonHeader,
    vueQr,
    MqttNotice
  },
  name: 'App',
  data () {
    return {
      isMenuExpand: false, // 是否展开二级路由
      userInfo: this.$store.state.userInfo // 登录账号信息
    }
  },
  created () {
    // 从缓存恢复菜单状态
    const cachedMenu = localStorage.getItem('SITE_SELECTED_MENU')
    if (cachedMenu) {
      let subMenu = JSON.parse(cachedMenu)
      if (subMenu.length) {
        this.$store.dispatch('setSubMenu', subMenu) // 存储子菜单到 Vuex 中
        this.$store.dispatch('setShowSubMenu', true) // 显示子菜单
      }
    }
  },
  methods: {
    // 新增：处理子菜单点击
    handleSubMenuClick (item) {
      this.toUrl(item.path)
    },
    isSubMenuActive (itemPath) {
      const routePath = (this.$route.path || '').replace(/^\/admin/, '')
      const normalizedItemPath = (itemPath || '').replace(/^\/admin/, '')
      return routePath === normalizedItemPath || routePath.startsWith(normalizedItemPath + '/')
    },
    // 切换子菜单显示状态
    toggleSubMenu () {
      this.$store.dispatch('setShowSubMenu', !this.$store.state.showSubMenu)
    }

  }
}
</script>

<style>
@import "./assets/css/public/index.css";
@import "./assets/css/public/apply.css";
@import "./assets/css/public/navbar.css";
@import "../static/iconfont.css";
</style>

<style scoped>
.layout-content {
  display: flex;
  overflow-y: auto;
}

body,
html {
  overflow: hidden;
}

.submenu-sider {
  width: 154px;
  background: #fff;
}

.submenu-container {
  position: relative;
}

.submenu-wrapper {
  width: 100%;
  height: 100%;
  background: #fff;
}

.submenu-wrapper .submenu-item {
  width: 154px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
  font-weight: 400;
  letter-spacing: 0px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}

.submenu-wrapper .active-submenu {
  color: rgba(66, 164, 255, 1);
  background: rgba(235, 244, 255, 1);
}

.show-btn {
  position: absolute;
  width: 15px;
  height: 65px;
  line-height: 51px;
  top: 48%;
  right: -12px;
  cursor: pointer;
  z-index: 1000;
  color: #198aff;
  padding: 0.5em 1em 0.35em;
}

.show-btn:before {
  content: '';
  position: absolute;
  top: 0;
  right: -14px;
  width: 100%;
  bottom: 0;
  z-index: -1;
  background: rgba(66, 164, 255, 1);
  border-radius: 0px 9px 9px 0px;
  transform: perspective(0.5em) rotateY(10deg);
  transform-origin: left;
  box-shadow: 8px 0 8px rgba(0, 0, 0, .1);
}

.content-body {
  flex: 1;
  overflow: auto;
}

.dark-header {
  background-color: #535A6C;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue